import { useEffect, useState } from 'react'

type BackgroundSize = 'contain' | 'cover'

interface ImageSizeProps {
    imageSrc: string
    largeImage?: boolean
}

const getBackgroundImageSize = ({
    imageSrc,
    largeImage
}: ImageSizeProps): BackgroundSize => {
    const [backgroundSize, setBackgroundSize] =
        useState<BackgroundSize>('cover')

    useEffect(() => {
        if (!imageSrc) return

        const img = new Image()
        img.src = imageSrc

        img.onload = () => {
            const isPortrait = img.naturalHeight > img.naturalWidth
            const size: BackgroundSize =
                isPortrait && !largeImage ? 'contain' : 'cover'
            setBackgroundSize(size)
        }
    }, [imageSrc, largeImage])

    return backgroundSize
}

export default getBackgroundImageSize
